import React, {
  Fragment,
  useState,
  forwardRef,
  useContext,
  useEffect,
  useCallback,
} from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components
import GridItem from 'components/Grid/GridItem.js'
import GridContainer from 'components/Grid/GridContainer.js'
import { Search, Layers } from '@material-ui/icons'
import Card from 'components/Card/Card.js'
import CardHeader from 'components/Card/CardHeader.js'
import CardBody from 'components/Card/CardBody.js'
import axios from 'axios'
import MaterialTable from 'material-table'
import { Grid, LinearProgress, Button } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import format from 'date-fns/format'
import Moment from 'moment'

import EnableResultsPsychometricsAdmin from 'views/dialog/EnableResultsPsychometricsAdmin'
import EnableResultsPsychometricsAdminColor from 'views/dialog/EnableResultsPsychometricsAdminColor'
import EnableInformationTestUser from 'views/dialog/EnableInformationTestUser'
import EnableRestartTestUserStop from 'views/dialog/EnableRestartTestUserStop'
import EnableSelectResultsTest from 'views/dialog/EnableSelectResultsTest'
import EnableStartAgainPsychometrics from 'views/dialog/EnableStartAgainPsychometrics'

import img from 'assets/img/loading.gif'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

export default function StatusJobsPsychometrics() {
  const classes = useStyles()

  const [rows, setRows] = useState([])
  const [loader, setLoader] = useState(true)
  const [error, setError] = useState(false)
  const [returnLogin, setReturnLogin] = useState(false)
  const [openResults, setOpenResults] = useState(false)
  const [openSelectResults, setOpenSelectResults] = useState(false)
  const [openResultsColor, setOpenResultsColor] = useState(false)
  const [idRow, setIdRow] = useState('')
  const [openInformation, setOpenInformation] = useState(false)
  const [openRestart, setOpenRestart] = useState(false)
  const [openEnableStartAgain, setOpenEnableStartAgain] = useState(false)
  const [searchText, setSearchText] = useState('')

  const keyAuthorization = localStorage.getItem('Session')
  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  }

  const columns = [
    {
      title: 'Candidato',
      field: 'allnames',
      width: '35%',
      cellStyle: {
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 12,
      },
    },
    {
      title: 'Prueba',
      field: 'jobtesttpm.test.name',
      width: '35%',
      cellStyle: {
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 12,
      },
    },
    {
      title: 'Cargo',
      // field: 'jobtesttpm.job.name',
      width: '35%',
      cellStyle: {
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 12,
      },
      render: (rowData) => {
        // Formatea la fecha (si es string como "25-08-05" o "2025-08-05")
        const formattedDate = Moment(
          rowData.presentationDay,
          'YYYY-MM-DD',
        ).isValid()
          ? Moment(rowData.presentationDay).format('DD-MM-YYYY')
          : rowData.presentationDay
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px', // Espacio entre elementos
            }}
          >
            <div style={{ fontSize: 10, fontWeight: 'bold' }}>
              {rowData.jobtesttpm?.job?.name}
            </div>
            {rowData.presentationDay &&
              rowData.startTimeDay &&
              rowData.endTimeDay && (
                <>
                  <div
                    style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}
                  >
                    Fecha: {formattedDate}
                  </div>
                  <div
                    style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}
                  >
                    Hora inicio:{' '}
                    {Moment(rowData.startTimeDay, 'HH:mm:ss').format('HH:mm')}{' '}
                    Hora fin:{' '}
                    {Moment(rowData.endTimeDay, 'HH:mm:ss').format('HH:mm')}
                  </div>
                </>
              )}
          </div>
        )
      },
    },
    {
      title: 'Estado',
      render: (rowData) => {
        const statusMap = {
          1: { text: 'POR COMENZAR', color: 'grey' },
          2: { text: 'INICIADA', color: 'blue' },
          3: { text: 'FINALIZADA', color: 'green' },
          4: { text: 'PAUSADA', color: 'orange' },
          5: { text: 'INACTIVA', color: 'red' },
        }
        const { text, color } = statusMap[rowData.status]
        return (
          <Fragment>
            <b style={{ color }}>{text}</b>{' '}
            {rowData.status === 2 && <LinearProgress />}
          </Fragment>
        )
      },
      width: '5%',
      cellStyle: {
        textAlign: 'CENTER',
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 10,
      },
    },
    {
      title: 'Iniciada',
      render: (rowData) =>
        rowData.startDate
          ? format(new Date(rowData.startDate), 'dd-MM-yyyy kk:mm:ss')
          : '',
      width: '8%',
      cellStyle: {
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 12,
        textAlign: 'center',
        color: 'green',
        fontWeight: 'bold',
      },
    },
    {
      title: 'Finalizada',
      render: (rowData) =>
        rowData.endDate
          ? format(new Date(rowData.endDate), 'dd-MM-yyyy kk:mm:ss')
          : '',
      width: '8%',
      cellStyle: {
        border: '1px solid rgb(241, 241, 241)',
        fontSize: 12,
        textAlign: 'center',
        color: 'green',
        fontWeight: 'bold',
      },
    },
    {
      title: '---',
      render: (rowData) => {
        // 1. Obtener fecha y hora actual
        const now = Moment() // Fecha y hora actual (ej: "2025-08-07T14:30:00")

        // 2. Parsear fecha y horas del rowData
        const presentationDate = Moment(rowData.presentationDay, 'YYYY-MM-DD')
        const startTime = Moment(rowData.startTimeDay, 'HH:mm:ss')
        const endTime = Moment(rowData.endTimeDay, 'HH:mm:ss')

        // 3. Validar si es el mismo día (presentationDay = hoy)
        const isToday = presentationDate.isSame(now, 'day')

        // 4. Validar si la hora actual está dentro del rango (startTime ≤ now ≤ endTime)
        /* const isWithinTimeRange =
          isToday && now.isSameOrAfter(startTime) && now.isSameOrBefore(endTime)*/

        const adminAgain = rowData.startAgain
          ? JSON.parse(rowData.startAgain)
          : null
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {rowData.status === 3 || rowData.status === 22 ? (
              <>
                <Button
                  size="small"
                  style={{
                    width: 110,
                    fontSize: 8,
                    padding: '5px 2px',
                    borderRadius: 8,
                  }}
                  className={classes.buttonSubmit4}
                  onClick={() => OpenResult(rowData)}
                >
                  RESULTADOS
                </Button>
                {rowData.jobtesttpm.testId === 21 &&
                  rowData.jobtesttpm.test.testsuserstpm.length > 0 &&
                  rowData.jobtesttpm.test.testsuserstpm[0].viewTest === 1 && (
                    <Button
                      size="small"
                      style={{
                        width: 110,
                        fontSize: 8,
                        padding: '5px 2px',
                        borderRadius: 8,
                        marginTop: 5,
                      }}
                      className={classes.buttonContactGreen}
                      onClick={() => OpenSelectResult(rowData)}
                    >
                      VER PRUEBA
                    </Button>
                  )}
              </>
            ) : rowData.status === 2 ? (
              <>
                <Button
                  size="small"
                  style={{
                    width: 110,
                    fontSize: 8,
                    padding: '5px 2px',
                    borderRadius: 8,
                  }}
                  className={classes.buttonSubmit5}
                  onClick={() => OpenInformation(rowData)}
                >
                  INFORMACIÓN Y PAUSAR
                </Button>

                {/* Mostrar "Activar prueba" SOLO si está dentro del rango */}
                {/*isWithinTimeRange && (*/}

                <Button
                  size="small"
                  style={{
                    width: 110,
                    fontSize: 8,
                    padding: '5px 2px',
                    borderRadius: 8,
                    marginTop: 5,
                  }}
                  className={classes.buttonContactGreen}
                  onClick={() => OpenEnableStartAgainValue(rowData)}
                >
                  ACTIVAR PRUEBA
                </Button>
                {rowData.startAgain && (
                  <center>
                    <div
                      style={{
                        fontSize: 8,
                        width: '95px',
                        background: '#F6F6F6',
                        padding: 4,
                        fontWeight: '450',
                        marginTop: 3,
                      }}
                    >
                      Prueba activada por el administrador{' '}
                      <span style={{ color: '#000', fontWeight: 'bold' }}>
                        {adminAgain?.user}
                        {/*en la fecha{' '}
                            <span style={{ color: '#000', fontWeight: 'bold' }}>
                              {Moment(adminAgain?.date).format('DD-MM-YYYY')}
                            </span>{' '}*/}
                      </span>
                    </div>
                  </center>
                )}
                {/*)}*/}
              </>
            ) : rowData.status === 4 ? (
              <Button
                size="small"
                style={{
                  width: 110,
                  fontSize: 8,
                  padding: '5px 2px',
                  borderRadius: 8,
                }}
                className={classes.buttonSubmit5}
                onClick={() => OpenRestart(rowData)}
              >
                REANUDAR Y ACTIVAR
              </Button>
            ) : (
              <>
                <Button
                  size="small"
                  style={{
                    width: 110,
                    fontSize: 8,
                    padding: '5px 2px',
                    borderRadius: 8,
                  }}
                  className={classes.buttonSubmit4}
                  disabled
                >
                  RESULTADOS
                </Button>
                {rowData.startAgain && (
                  <center>
                    <div
                      style={{
                        fontSize: 8,
                        width: '95px',
                        background: '#F6F6F6',
                        padding: 4,
                        fontWeight: '450',
                        marginTop: 3,
                      }}
                    >
                      Prueba activada por el administrador{' '}
                      <span style={{ color: '#000', fontWeight: 'bold' }}>
                        {adminAgain?.user}
                        {/*en la fecha{' '}
                            <span style={{ color: '#000', fontWeight: 'bold' }}>
                              {Moment(adminAgain?.date).format('DD-MM-YYYY')}
                            </span>{' '}*/}
                      </span>
                    </div>
                  </center>
                )}
              </>
            )}
          </div>
        )
      },
      width: '3%',
      cellStyle: {
        textAlign: 'CENTER',
        border: '1px solid rgb(241, 241, 241)',
      },
      sorting: false,
    },
  ]

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${urlServices}jobs-users-tpm/account/${localStorage.getItem(
          'account_id',
        )}`,
        {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        },
      )
      if (response.status === 200) {
        if (response.data.length > 0) {
          // Agregar el campo allnames
          const updatedData = response.data.map((item) => ({
            ...item,
            allnames: `${item.applicant?.name || ''} ${
              item.applicant?.lastName || ''
            }`.trim(),
          }))

          const sortedData = updatedData.sort(
            (a, b) => new Date(b.startDate) - new Date(a.startDate),
          )

          setRows(sortedData)
        }
      }
    } catch (e) {
      if (e.response.status === 404) {
        setRows([])
      } else if (e.response.status === 401) {
        localStorage.clear()
        setReturnLogin(true)
      } else {
        setError(true)
        console.error(e)
      }
    } finally {
      setLoader(false)
    }
  }, [keyAplication, urlServices, keyAuthorization])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    fetchData()
  }, [fetchData])

  // Función de filtrado
  const filteredData = rows.filter((row) => {
    if (!searchText) return true

    const searchLower = searchText.toLowerCase()
    return (
      row.allnames?.toLowerCase().includes(searchLower) ||
      row.jobtesttpm?.test?.name?.toLowerCase().includes(searchLower) ||
      row.jobtesttpm?.job?.name?.toLowerCase().includes(searchLower)
    )
  })

  const RefreshTable = useCallback(() => {
    setLoader(true)
    fetchData()
  }, [fetchData])

  const OpenInformation = (data) => {
    let out = {
      id: data.id,
      testId: data.jobtesttpm.testId,
      testName: data.jobtesttpm.test.name,
      userId: data.applicantId,
      userNames: data.applicant.name + ' ' + data.applicant.lastName,
    }

    setIdRow(out)
    setOpenInformation(true)
  }

  const OpenResult = (data) => {
    const out = {
      jobId: data.jobtesttpm.jobId,
      testName: data.jobtesttpm.test.name,
      testId: data.jobtesttpm.testId,
      userId: data.applicant.id,
      userNames: `${data.applicant.name} ${data.applicant.lastName}`,
      userDocument: data.applicant.documentId,
      userGender: data.applicant.genderId || 1,
    }

    setIdRow(out)
    if (data.jobtesttpm.testId !== 12) {
      setOpenResults(true)
    } else {
      setOpenResultsColor(true)
    }
  }

  const OpenSelectResult = (data) => {
    setIdRow(data)
    setOpenSelectResults(true)
  }

  const OpenEnableStartAgainValue = (data) => {
    setIdRow(data)
    setOpenEnableStartAgain(true)
  }

  const OpenRestart = (data) => {
    setIdRow(data)
    setOpenRestart(true)
  }

  const handleCloseOpenInformation = () => {
    setOpenInformation(false)
  }

  const handleCloseOpenRestart = () => {
    setOpenRestart(false)
  }

  const handleCloseOpenResults = () => setOpenResults(false)
  const handleCloseOpenSelectResults = () => setOpenSelectResults(false)
  const handleCloseOpenResultsColor = () => setOpenResultsColor(false)
  const handleCloseOpenEnableStartAgain = () => setOpenEnableStartAgain(false)

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <Layers className={classes.iconWhite} /> Listado de estado de
              pruebas
            </div>
          </CardHeader>
          <CardBody>
            {error && (
              <Alert severity="error">
                Error en la consulta con el servidor.
              </Alert>
            )}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      src={img}
                      alt="loader"
                      style={{
                        width: 60,
                        margin: '100px 0',
                      }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <MaterialTable
                  title=""
                  columns={columns}
                  style={{
                    boxShadow: 'unset',
                    border: '1px solid rgb(241, 241, 241)',
                  }}
                  data={rows}
                  localization={{
                    pagination: {
                      labelRowsSelect: 'Filas',
                      labelDisplayedRows: '{from}-{to} de {count}',
                      firstTooltip: 'Primera página',
                      previousTooltip: 'Previo',
                      nextTooltip: 'Siguiente',
                      lastTooltip: 'Última página',
                    },
                    toolbar: {
                      searchTooltip: 'Buscar candidato, prueba o cargo',
                      searchPlaceholder: 'Buscar...',
                    },
                    header: {
                      actions: ' --- ',
                    },
                    body: {
                      emptyDataSourceMessage: 'No hay datos.',
                      filterRow: {
                        filterTooltip: 'Filtro',
                      },
                    },
                  }}
                  actions={[
                    {
                      icon: 'refresh',
                      tooltip: 'Refresh Data',
                      isFreeAction: true,
                      onClick: RefreshTable,
                    },
                  ]}
                  icons={tableIcons}
                  options={{
                    search: true,
                    searchFieldAlignment: 'left',
                    searchFieldStyle: {
                      width: '300px',
                      marginLeft: '10px',
                    },
                    searchAutoFocus: true,
                    searchText: searchText,
                    onSearchChange: (value) => setSearchText(value),
                    padding: 'default',
                    filtering: false,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    headerStyle: {
                      background: '#F2F2F2',
                      padding: '1%',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    },
                    cellStyle: { border: '1px solid #DDDDDD' },
                  }}
                />
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openResults && (
        <EnableResultsPsychometricsAdmin
          open={openResults}
          exit={handleCloseOpenResults}
          id={idRow}
        />
      )}
      {openSelectResults && (
        <EnableSelectResultsTest
          open={openSelectResults}
          exit={handleCloseOpenSelectResults}
          id={idRow}
        />
      )}
      {openInformation && (
        <EnableInformationTestUser
          open={openInformation}
          exit={handleCloseOpenInformation}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="jobs-users-tpm"
        />
      )}
      {openRestart && (
        <EnableRestartTestUserStop
          open={openRestart}
          exit={handleCloseOpenRestart}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="jobs-users-tpm"
        />
      )}
      {openResultsColor && (
        <EnableResultsPsychometricsAdminColor
          open={openResultsColor}
          exit={handleCloseOpenResultsColor}
          id={idRow}
        />
      )}
      {openEnableStartAgain && (
        <EnableStartAgainPsychometrics
          open={openEnableStartAgain}
          exit={handleCloseOpenEnableStartAgain}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
    </GridContainer>
  )
}
